export const POS_NAVBAR_CART_STATE_EVENT = 'pos-navbar-cart-state';
export const POS_NAVBAR_CART_OPEN_EVENT = 'pos-navbar-cart-open';

const hasWindow = () => typeof window !== 'undefined';

export const publishPosNavbarCartState = ({ visible = false, totalAmount = 0 } = {}) => {
  if (!hasWindow()) return;
  const parsedTotal = Number(totalAmount);
  const safeTotal = Number.isFinite(parsedTotal) ? parsedTotal : 0;
  window.dispatchEvent(
    new CustomEvent(POS_NAVBAR_CART_STATE_EVENT, {
      detail: {
        visible: Boolean(visible),
        totalAmount: safeTotal,
      },
    })
  );
};

export const clearPosNavbarCartState = () => {
  publishPosNavbarCartState({ visible: false, totalAmount: 0 });
};

export const requestOpenPosNavbarCart = () => {
  if (!hasWindow()) return;
  window.dispatchEvent(new CustomEvent(POS_NAVBAR_CART_OPEN_EVENT));
};

export const subscribePosNavbarCartState = (handler) => {
  if (!hasWindow() || typeof handler !== 'function') {
    return () => {};
  }
  window.addEventListener(POS_NAVBAR_CART_STATE_EVENT, handler);
  return () => window.removeEventListener(POS_NAVBAR_CART_STATE_EVENT, handler);
};

export const subscribePosNavbarCartOpen = (handler) => {
  if (!hasWindow() || typeof handler !== 'function') {
    return () => {};
  }
  window.addEventListener(POS_NAVBAR_CART_OPEN_EVENT, handler);
  return () => window.removeEventListener(POS_NAVBAR_CART_OPEN_EVENT, handler);
};
